import apiClient from "./config";
import {
  DASHBOARD_ANALYTICS_ENDPOINTS,
  DASHBOARD_CRM_ENDPOINTS,
  DASHBOARD_ECOMMERCE_ENDPOINTS,
  DASHBOARD_CRYPTO_ENDPOINTS,
  DASHBOARD_PROJECT_ENDPOINTS,
  DASHBOARD_NFT_ENDPOINTS,
} from "./endpoints";

// Dashboard Analytics
export const getAllData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_ALL_DATA);
export const getHalfYearlyData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_HALFYEARLY_DATA);
export const getMonthlyData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_MONTHLY_DATA);

// Audiences Metrics
export const getAllAudiencesMetricsData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_ALLAUDIENCESMETRICS_DATA);
export const getMonthlyAudiencesMetricsData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_MONTHLYAUDIENCESMETRICS_DATA);
export const getHalfYearlyAudiencesMetricsData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_HALFYEARLYAUDIENCESMETRICS_DATA);
export const getYearlyAudiencesMetricsData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_YEARLYAUDIENCESMETRICS_DATA);

// Users by Device
export const getTodayDeviceData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_TODAYDEVICE_DATA);
export const getLastWeekDeviceData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_LASTWEEKDEVICE_DATA);
export const getLastMonthDeviceData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_LASTMONTHDEVICE_DATA);
export const getCurrentYearDeviceData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_CURRENTYEARDEVICE_DATA);

// Audiences Sessions by Country
export const getTodaySessionData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_TODAYSESSION_DATA);
export const getLastWeekSessionData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_LASTWEEKSESSION_DATA);
export const getLastMonthSessionData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_LASTMONTHSESSION_DATA);
export const getCurrentYearSessionData = () => apiClient.get(DASHBOARD_ANALYTICS_ENDPOINTS.GET_CURRENTYEARSESSION_DATA);

// Dashboard CRM
// Balance Overview
export const getTodayBalanceData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_TODAYBALANCE_DATA);
export const getLastWeekBalanceData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_LASTWEEKBALANCE_DATA);
export const getLastMonthBalanceData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_LASTMONTHBALANCE_DATA);
export const getCurrentYearBalanceData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_CURRENTYEARBALANCE_DATA);

// Deal Type
export const getTodayDealData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_TODAYDEAL_DATA);
export const getWeeklyDealData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_WEEKLYDEAL_DATA);
export const getMonthlyDealData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_MONTHLYDEAL_DATA);
export const getYearlyDealData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_YEARLYDEAL_DATA);

// Sales Forecast
export const getOctSalesData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_OCTSALES_DATA);
export const getNovSalesData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_NOVSALES_DATA);
export const getDecSalesData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_DECSALES_DATA);
export const getJanSalesData = () => apiClient.get(DASHBOARD_CRM_ENDPOINTS.GET_JANSALES_DATA);

// Dashboard Ecommerce
// Revenue
export const getAllRevenueData = () => apiClient.get(DASHBOARD_ECOMMERCE_ENDPOINTS.GET_ALLREVENUE_DATA);
export const getMonthRevenueData = () => apiClient.get(DASHBOARD_ECOMMERCE_ENDPOINTS.GET_MONTHREVENUE_DATA);
export const getHalfYearRevenueData = () => apiClient.get(DASHBOARD_ECOMMERCE_ENDPOINTS.GET_HALFYEARREVENUE_DATA);
export const getYearRevenueData = () => apiClient.get(DASHBOARD_ECOMMERCE_ENDPOINTS.GET_YEARREVENUE_DATA);

// Dashboard Crypto
// Portfolio
export const getBtcPortfolioData = () => apiClient.get(DASHBOARD_CRYPTO_ENDPOINTS.GET_BTCPORTFOLIO_DATA);
export const getUsdPortfolioData = () => apiClient.get(DASHBOARD_CRYPTO_ENDPOINTS.GET_USDPORTFOLIO_DATA);
export const getEuroPortfolioData = () => apiClient.get(DASHBOARD_CRYPTO_ENDPOINTS.GET_EUROPORTFOLIO_DATA);

// Market Graph
export const getAllMarketData = () => apiClient.get(DASHBOARD_CRYPTO_ENDPOINTS.GET_ALLMARKETDATA_DATA);
export const getYearMarketData = () => apiClient.get(DASHBOARD_CRYPTO_ENDPOINTS.GET_YEARMARKET_DATA);
export const getMonthMarketData = () => apiClient.get(DASHBOARD_CRYPTO_ENDPOINTS.GET_MONTHMARKET_DATA);
export const getWeekMarketData = () => apiClient.get(DASHBOARD_CRYPTO_ENDPOINTS.GET_WEEKMARKET_DATA);
export const getHourMarketData = () => apiClient.get(DASHBOARD_CRYPTO_ENDPOINTS.GET_HOURMARKET_DATA);

// Dashboard Project
// Project Overview
export const getAllProjectData = () => apiClient.get(DASHBOARD_PROJECT_ENDPOINTS.GET_ALLPROJECT_DATA);
export const getMonthProjectData = () => apiClient.get(DASHBOARD_PROJECT_ENDPOINTS.GET_MONTHPROJECT_DATA);
export const gethalfYearProjectData = () => apiClient.get(DASHBOARD_PROJECT_ENDPOINTS.GET_HALFYEARPROJECT_DATA);
export const getYearProjectData = () => apiClient.get(DASHBOARD_PROJECT_ENDPOINTS.GET_YEARPROJECT_DATA);

// Project Status
export const getAllProjectStatusData = () => apiClient.get(DASHBOARD_PROJECT_ENDPOINTS.GET_ALLPROJECTSTATUS_DATA);
export const getWeekProjectStatusData = () => apiClient.get(DASHBOARD_PROJECT_ENDPOINTS.GET_WEEKPROJECTSTATUS_DATA);
export const getMonthProjectStatusData = () => apiClient.get(DASHBOARD_PROJECT_ENDPOINTS.GET_MONTHPROJECTSTATUS_DATA);
export const getQuarterProjectStatusData = () => apiClient.get(DASHBOARD_PROJECT_ENDPOINTS.GET_QUARTERPROJECTSTATUS_DATA);

// Dashboard NFT
// Marketplace
export const getAllMarketplaceData = () => apiClient.get(DASHBOARD_NFT_ENDPOINTS.GET_ALLMARKETPLACE_DATA);
export const getMonthMarketplaceData = () => apiClient.get(DASHBOARD_NFT_ENDPOINTS.GET_MONTHMARKETPLACE_DATA);
export const gethalfYearMarketplaceData = () => apiClient.get(DASHBOARD_NFT_ENDPOINTS.GET_HALFYEARMARKETPLACE_DATA);
export const getYearMarketplaceData = () => apiClient.get(DASHBOARD_NFT_ENDPOINTS.GET_YEARMARKETPLACE_DATA);

